import type { ITabService, ITabUtils, TabInfo } from 'clickim/src/background/session/ITabService';

/** This is just a mock class hopefully we can remove after we set up types and backwards-compatibility in clickim */
export class TabServiceMock implements ITabService {
    public sessionTabs = {};

    on() { /* noop */ }

    tabCount() {
        return undefined;
    }

    getAllOpenTabIds() {
        return [];
    }

    isSessionTab() {
        return false;
    }

    getAllTabInfos() {
        return {};
    }

    async addNewTab() { /* noop */ }
    addOpenerStepId() { /* noop - probably safe to remove */ }
    addOpenerStep() { /* noop */ }

    getTabUtilsByTabIdAndSessionId() {
        return undefined;
    }

    getTabUtilsByTabId() {
        return {} as ITabUtils;
    }

    getTabInfo() {
        return {} as TabInfo;
    }

    getTabUtils() {
        return {} as ITabUtils;
    }

    getMainTabInfo() { /* noop - probably safe to remove */ }

    getMainTabUtils() {
        return {} as ITabUtils;
    }

    getMainTabId() {
        return null;
    }

    async isMainTabExists() {
        return false;
    }

    clearAllTabs() { /* noop */ }

    async switchTab() { /* noop */ }

    async getTabDetails() { /* noop */ }

    async isMainTabIncognito() {
        return false;
    }

    async getTabIdByTabInfo() {
        return NaN;
    }
}
